import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import * as fs from 'file-saver';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AssessRequestRaService } from '../assess-request-ra/assess-request-ra.service';
import { HELPTABLE_COLUMNS } from '../common/models/tableColumns';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as _ from 'lodash';
@Component({
  selector: 'app-help-page',
  templateUrl: './help-page.component.html',
  styleUrls: ['./help-page.component.scss']
})
export class HelpPageComponent implements OnInit {
  filenameText: any;
  constructor(public matSnackBar: MatSnackBar, private reqSvc: AssessRequestRaService, private http: HttpClient) { }
  @ViewChild('helptableDiv') rowHoverDiv: ElementRef;
  @ViewChild('helptableDivRD') rowHoverDivRD: ElementRef;
  activeTabUR = 'leadc';
  helpTableListColumns = [];
  helpRAListData = [];
  helpRDListData = [];
  selectedRowData: any = [];
  uploadDialog = false;
  loading = false;
  extension = '.pdf';
  rowData = [];
  step = 0;
  leadContactsBPC = [];
  leadContactsFnR = [];
  leadContactsHC = [];
  UploadData: any = [];
  uploadedFiles: any[] = [];
  roleName = '';
  ngOnInit() {
    const roleData = localStorage.getItem('roles');
    const data = roleData.split(',');
    let listRole = [];
    for (const val of data) {
      if (val.toLowerCase().startsWith('fast')) {
        listRole.push(val);
      }
    }
    listRole = _.uniqBy(listRole);
    this.roleName = listRole.join(',');
    this.loading = true;
    this.helpTableListColumns = HELPTABLE_COLUMNS;
    const functionApiUrl = environment.APIFAsT + '/help/allFAQs';
    this.getLeadContactsList();
    this.reqSvc.getData(functionApiUrl).subscribe((response) => {
      this.loading = false;
      for (const value of response) {
        if (value.questionCategory === 'FAsT - RnD') {
          this.helpRDListData.push(value);
        } else if (value.questionCategory === 'FAsT - RA') {
          this.helpRAListData.push(value);
        }
      }
    }, (error) => {
      this.loading = false;
    });
  }
  onTabChange(activeTab) {
    // this.hideFloatingIcons();
    this.activeTabUR = activeTab;
  }
  /* istanbul ignore next */
  showFloatingIcons(event, rowData) {
    this.selectedRowData = rowData;
    this.rowData = rowData;
    event.target.dataTypeElem = 'row';
    setTimeout(() => {
      const htmlRowElm = document.getElementById('helptableDiv');
      const adj = (window.screen.width === window.outerWidth) ? 0 : -15;
      htmlRowElm.style.display = 'block';
      htmlRowElm.style.left = String(event.pageX + 15) + 'px';
      if (event.pageY > 400) {
        htmlRowElm.style.top = (event.pageY - 180) + 'px';
      } else {
        htmlRowElm.style.top = (event.pageY - 10) + 'px';
      }
    }, 100);
  }
  downloadlinkFile(rowData) {
    this.selectedRowData = rowData;
    this.rowData = rowData;
    this.downloadFile();
  }
  showFloatingIconsRD(event, rowData) {
    this.selectedRowData = rowData;
    this.rowData = rowData;
    event.target.dataTypeElem = 'row';
    setTimeout(() => {
      const htmlDivElm = document.getElementById('helptableDivRD');
      const adj = (window.screen.width === window.outerWidth) ? 0 : -15;
      htmlDivElm.style.display = 'block';
      htmlDivElm.style.left = String(event.pageX + 15) + 'px';
      if (event.pageY > 400) {
        htmlDivElm.style.top = (event.pageY - 180) + 'px';
      } else {
        htmlDivElm.style.top = (event.pageY - 10) + 'px';
      }
    }, 100);
  }
  hideFloatingIcons() {
    this.rowHoverDiv.nativeElement.style.display = 'none';
    this.rowHoverDivRD.nativeElement.style.display = 'none';
  }
  downloadFile() {
    this.loading = true;
    const fileURL = environment.APIFAsT + '/help/FAQ/' + this.selectedRowData.faqId;
    this.reqSvc.downloadFile(fileURL).subscribe((response) => {
      this.loading = false;
      if (this.selectedRowData.storageFileName.indexOf('.') !== -1) {
        this.extension = this.selectedRowData.storageFileName.substring(this.selectedRowData.storageFileName.indexOf('.'));
      }
      fs.saveAs(response, this.selectedRowData.questionDesc + this.extension);
    }, (error) => {
      this.loading = false;
    });
  }
  mousehoverpop(event) {
    event.stopPropagation();
  }
  setStep(index: number) {
    this.step = index;
  }
  getLeadContactsList() {
    const apiurl = environment.APIFAsT + '/getLeadContactsManagement';
    const apiBody = {
      id: null,
      groupTypeId: '4',
      name: null, email: null, active: null, divisionId: null,
      submittedBy: null, submittedDate: null, updatedBy: null, updatedDate: null
    };
    this.leadContactsBPC = [];
    this.leadContactsFnR = [];
    this.leadContactsHC = [];
    this.reqSvc.postData(apiurl, apiBody).subscribe((response) => {
      this.loading = false;
      response.forEach(element => {
        if (element.active === 'Active') {
          if (element.divisionId === 'BPC') {
            this.leadContactsBPC.push({ name: element.name, email: element.email });
          } else if (element.divisionId === 'F&R') {
            this.leadContactsFnR.push({ name: element.name, email: element.email });
          } else if (element.divisionId === 'HC') {
            this.leadContactsHC.push({ name: element.name, email: element.email });
          }
        }
      });
      console.log(this.leadContactsBPC);
    }, (error) => {
      this.loading = false;
    });
  }
  UploadDialog() {
    this.uploadDialog = true;
  }
  onUpload(event, fileuploadForm) {
    this.uploadedFiles = [];
    this.filenameText = event.files[0].name;
    for (const file of event.files) {
      this.uploadedFiles.push(file);
    }
    fileuploadForm.clear();
    // this.loadingmappinglistMessage = 'Loading data in Composition Details table';
    const fileToUpload = <File> this.uploadedFiles[0];
    const apiurl = environment.APIFAsT + '/nonplmrecipe/uploadfiletoblob';
    this.loading = true;
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    const headerdata = new HttpHeaders({
      Authorization: 'Bearer ' + localStorage.getItem('FunctionToken'),
      'X-FAST-AUTH-K': '6ee2a098-e2d6-4893-b8b4-18f01c9a67a1-6DB1487E-C741-4669-B8BB-9F34EE294EEF'
    });
    this.http.post<any>(apiurl, formData, { headers: headerdata })
      .subscribe((response) => {
        this.UploadData = response;
        // console.log(this.UploadData);
        this.loading = false;
        this.matSnackBar.open('File uploaded successfully.', 'close', {
          duration: 3000,
          panelClass: ['success']
        });
        this.uploadDialog = false;

      }, (error) => {
        this.uploadDialog = false;
        this.loading = false;
        if (error.error.message !== undefined) {
          this.matSnackBar.open(error.error.message, 'close', {
            duration: 5000,
            panelClass: ['error']
          });
        }
      });
  }
}
